export default __webpack_public_path__ + "static/media/img8.a41d707b.png";